<ng-template #modalLG let-modal >
  <div class="modal-header bg-white py-2">
    <button type="button" class="close" (click)="cancelModal()">
      <span aria-hidden="true">×</span>
    </button>
  </div>

  <div class="modal-body p-0" tabindex="0" ngbAutofocus >
    <div *ngIf="modalType === 'ajouter'" style="padding: 10px 64px 64px 64px">
      <div class="text-center p-0">
          <p class="titre">Ajoutez un prix</p>
        <p class="p-0" style="margin-bottom: 24px">Veuillez indiquer le nom associé au prix.</p>
      </div>
      <form #prixForm="ngForm" (ngSubmit)="savePrix()">
        <div>
          <div class="col-12 p-0 m-0">
            <label for="priceName">Nom de prix</label>
            <input
              type="text"
              id="priceName"
              name="priceName"
              class="form-control"
              placeholder="Ex: prix de gros"
              aria-describedby="priceNameHelp"
              [(ngModel)]="priceName"
              required
              maxlength="200"
              #priceNameInput="ngModel"
              [ngClass]="{'is-invalid': priceNameInput.invalid && (priceNameInput.dirty || priceNameInput.touched || prixForm.submitted)}"
              (input)="checkLengthOnce()" 
            />
            <div *ngIf="priceNameInput.invalid && (priceNameInput.dirty || priceNameInput.touched || prixForm.submitted)" class="invalid-feedback">
              <span *ngIf="priceNameInput.errors?.['required']">Le nom du prix est requis.</span>
              <span *ngIf="priceNameInput.errors?.['maxlength']">Le nom du prix ne doit pas dépasser 200 caractères.</span>
            </div>
            <div *ngIf="showErrorOnce && priceName.length > 200" class="text-danger">Le nom du prix dépasse 200 caractères. Veuillez le réduire.</div> 
            <!--<small class="text-muted">Maximum 200 caractères. ({{ priceName.length }}/200)</small>  -->
          </div>

            <div class="text-center" style="margin-top: 24px">
                <button
                        type="submit"
                        class="btn btn-primary mr-2"
                        [disabled]="prixForm.invalid || isLoading || (showErrorOnce && priceName.length > 200)"
                >Valider</button>
                <button type="button" class="btn btn-default" style="background-color: #80839029;" (click)="cancelModal()" [disabled]="isLoading">Annuler</button>
            </div>
        </div>
      </form>
    </div>


    <div *ngIf="modalType === 'update'"style="padding: 10px 64px 64px 64px">
      <div class="text-center p-0">
          <p class="titre">Modifiez un prix</p>
          <p class="p-0" style="margin-bottom: 24px">Veuillez indiquer le nouveau nom du prix.</p>
      </div>
      <form #prixForm="ngForm" (ngSubmit)="savePrix()">
        <div>
          <div class="col-12 p-0 m-0">
            <label for="priceName">Nom de prix</label>
            <input
              type="text"
              id="priceName"
              name="priceName"
              class="form-control"
              [value]="selectedPrix?.libelle || ''"
              aria-describedby="priceNameHelp"
              [(ngModel)]="priceName"
              required
              maxlength="200"
              #priceNameInput="ngModel"
              [ngClass]="{'is-invalid': priceNameInput.invalid && (priceNameInput.dirty || priceNameInput.touched || prixForm.submitted)}"
              (input)="checkLengthOnce()" 
            />
            <div *ngIf="priceNameInput.invalid && (priceNameInput.dirty || priceNameInput.touched || prixForm.submitted)" class="invalid-feedback">
              <span *ngIf="priceNameInput.errors?.['required']">Le nom du prix est requis.</span>
              <span *ngIf="priceNameInput.errors?.['maxlength']">Le nom du prix ne doit pas dépasser 200 caractères.</span>
            </div>
            <div *ngIf="showErrorOnce && priceName.length > 200" class="text-danger">Le nom du prix dépasse 200 caractères. Veuillez le réduire.</div>
          </div>


          <div class="text-center" style="margin-top: 24px">
          <button
            type="submit"
            class="btn btn-primary mr-2"
            [disabled]="prixForm.invalid || isLoading || (showErrorOnce && priceName.length > 200)"
          >
            <span>Valider</span>
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status">
              <span class="sr-only">Chargement...</span>
            </span>
          </button>
          <button type="button" class="btn btn-default" style="background-color: #80839029;" (click)="cancelModal()" [disabled]="isLoading">Annuler</button>
        </div>
        </div>
      </form>
    </div>




    <div *ngIf="modalType === 'etat'">
      <div class="text-center" style="margin: 10px 64px 64px 64px">
        <p class="titre" style="margin-bottom: 8px">{{ selectedPrix?.statut ? 'Désactivation' : 'Activation' }} prix</p>
        <p style="margin-bottom: 24px">Êtes-vous sûr de vouloir {{ selectedPrix?.statut ? 'désactiver' : 'activer' }} le prix {{ selectedPrix?.libelle }} ?</p>
        <button class="btn btn-primary mr-2" (click)="savePrix()" [disabled]="isLoading">Confirmer</button>
        <button class="btn btn-default" style="background-color: #80839029;" (click)="cancelModal()" [disabled]="isLoading">Annuler</button>
      </div>
    </div>
  </div>
</ng-template>
